import React, { useCallback, useState, FormEvent } from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { MdInfo } from 'react-icons/md';
import ReactTooltip from 'react-tooltip';
import * as Yup from 'yup';
import Input from '../../Input/Input';
import Button from '../../Button';
import { useRegister } from '../../../hooks/register';
import { ErrorMessage, SignHeadText } from '../../../styles/globalStyled';
import {
 DescriptionContent, IconTooltip, SignupModalContainer, BackButton
} from '../styles';
import { getErrorMessage } from '../../../utils/validations/errors';
import { loginEmail } from '../../../services/login';

const EmailSignUp: React.FC = () => {
  const { handleData, handleStep, userData } = useRegister();
  const [email, setEmail] = useState(userData?.email || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const validation = Yup.string().required('Este é um campo obrigatório').email('Insira um email válido');

  const isValid = () => validation.isValidSync(email);

  const handleChange = (value: string) => {
    setError('');
    setEmail(value);
    handleData({ email: value.toLocaleLowerCase() });
  };

  const onSubmit = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      setError('');

      if (isValid()) {
        setLoading(true);

        try {
          const { data } = await loginEmail({ email });
          if (data.statusCode === 401) {
            setError('Este email já está sendo utilizado, por favor insira outro.');
          } else {
            handleStep('fillPassword');
          }
          setLoading(false);
        } catch (e) {
          setError('Ocorreu um erro inesperado, por favor tente novamente.');
          setLoading(false);
        }
      } else {
        const errorMessage = await getErrorMessage(validation, email);
        setError(errorMessage);
      }
    },
    [email],
  );

  return (
    <SignupModalContainer>
      <SignHeadText>
        <label>Por favor, informe seu e-mail</label>
        <DescriptionContent>
          <p>Porque precisamos dessas informações?</p>
          <IconTooltip data-for="cpfTooltip" data-tip="1">
            <MdInfo size={20} />
          </IconTooltip>
          <ReactTooltip
            id="cpfTooltip"
            globalEventOff="click"
            effect="solid"
            delayHide={500}
            place={'bottom'}
            type={'light'}
          >
            Utilizamos o e-mail para evento de recuperação de senha e comunicações da plataforma.
          </ReactTooltip>
        </DescriptionContent>
      </SignHeadText>
      <form onSubmit={onSubmit}>
        <Input
          autoFocus
          disabled={loading}
          name="email"
          type="text"
          placeholder="E-mail"
          width="full"
          value={email}
          onChangeValue={handleChange}
        />
        <ErrorMessage visibility={error ? 1 : 0}>
          <FiAlertCircle size={20} />
          {error}
        </ErrorMessage>

        <Button
          title="Continuar"
          disabled={loading}
          loading={loading}
          classType={`big fat orange center topspace ${!isValid() ? 'disabled' : ''}`}
          type="submit"
        />

        <BackButton onClick={() => handleStep('fillCpf')} />
      </form>
    </SignupModalContainer>
  );
};

export default EmailSignUp;
